import { zodResolver } from "@mantine/form";
import { prescriptionDataSchema } from "beitary-shared";
import { z } from "zod";

const precriptionFormSchema = prescriptionDataSchema;

export type PrecriptionFormValues = z.infer<typeof precriptionFormSchema>;

export const rules = zodResolver(precriptionFormSchema);
